import { cn } from '@/core/utils/cn';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeStyles = {
  sm: 'w-4 h-4 border-[1.5px]',
  md: 'w-6 h-6 border-2',
  lg: 'w-10 h-10 border-[2.5px]',
};

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <div className={cn(
      'rounded-full border-hms-border border-t-hms-gold animate-spin',
      sizeStyles[size],
      className
    )} />
  );
}

export function LoadingOverlay({ message }: { message?: string }) {
  return (
    <div className="absolute inset-0 bg-hms-bg/80 flex flex-col items-center justify-center z-10 backdrop-blur-sm rounded-xl">
      <Spinner size="lg" />
      {message && <p className="text-[13px] text-hms-textSub mt-3">{message}</p>}
    </div>
  );
}
